import { useCallback } from 'react';
import { useConsole } from '../contexts/ConsoleContext';

/**
 * Hook para facilitar o logging de ações no console
 * 
 * Uso:
 * const { logAction } = useActionLogger();
 * logAction('UPLOAD_IMAGE', imageId, { filename: 'foto.jpg', width: 600 });
 */
export const useActionLogger = () => {
  const { addLog } = useConsole();

  /**
   * Registra uma ação no console
   * @param {string} actionType - Tipo da ação (ex: 'UPLOAD_IMAGE', 'APPLY_EFFECT')
   * @param {string|null} imageId - ID da imagem afetada (null para ações globais)
   * @param {object} details - Detalhes específicos da ação
   * @param {object} metadata - Metadados adicionais opcionais
   */
  const logAction = useCallback((actionType, imageId, details, metadata) => {
    return addLog(actionType, imageId, details, metadata);
  }, [addLog]);

  return { logAction };
};

export default useActionLogger;

